/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { MidasEffectError, IControlZoneNotification } from '@midas/shared/common';
import { createAction, props } from '@ngrx/store';

export const queryOverviewNotificationAction = createAction(
  '[OverviewNotificationAction] Query OverviewNotificationAction',
  props<{ limit: number; offset: number }>(),
);

export const queryOverviewNotificationActionSuccess = createAction(
  '[OverviewNotificationAction] Query OverviewNotificationAction Success',
  props<{ carts: IControlZoneNotification[]}>(),
);
export const queryOverviewNotificationActionError = createAction(
  '[OverviewNotificationAction] Query OverviewNotificationAction Error',
  props<MidasEffectError>(),
);

